import { isValid, parse } from 'date-fns';
import * as yup from 'yup';
export const parsedDate = (format = 'yyyy-MM-dd') => yup.date().transform(function (value, originalValue) {
    value = parse(originalValue, format, new Date());
    return isValid(value) ? value : yup.date.INVALID_DATE;
});
const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const isValidUuid = (input) => {
    return uuidRegex.test(input);
};
export const invalidHppSubdomains = ['www', 'ftp', 'payments', 'development', 'staging'];
// Taken from https://github.com/jquense/yup/blob/master/src/string.ts#L19C1-L22C139
export const emailRegex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
//# sourceMappingURL=validation.js.map